<div *ngIf="content.title" class="organizations__header">
  <air-title [title]="content.title" [region]="region" [isFirst]="isFirst"></air-title>
</div>
<div class="organizations" *ngIf="!loading && organizations">
  <a
    *ngFor="let organization of organizations"
    [airLink]="organization.url"
    [userEventSource]="userEventSource"
    [userEventLabel]="organization.title"
    class="organizations__link"
  >
    <img *ngIf="organization.logo" [src]="organization.logo.cropUrl" [alt]="organization.title" />
  </a>
</div>
